export default "__VITE_ASSET__4dda0e71__"